var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vc-date-picker',{attrs:{"locale":"pt-BR","value":_vm.value,"model-config":{
    type: 'string',
    mask: 'iso',
    timeAdjust: '00:00:00',
  }},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"default",fn:function({ inputValue, inputEvents }){return [_c('input',_vm._g({class:['bg-white border px-2 py-1', _vm.fullHeight && 'input-full-height'],attrs:{"type":"text","placeholder":"Selecione uma data"},domProps:{"value":inputValue}},inputEvents))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }